<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Project Charter: Form" @back="back">
            <common-training-header :withUser="true" :user_hash="isAttendant == false ? attendant : null"/>
        </a-page-header>

        <a-skeleton :loading="loading" active>
            <a-form-model :model="formData" :rules="rules" ref="ruleForm">
                <a-card type="inner" size="small">
                    <a-row type="flex">
                        <a-col flex="1 1 250px">
                            <a-card type="inner" size="small">
                                <a-form-model-item prop="title">
                                    <strong><font style="color: red">*</font> Judul:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.title }}
                                    </div>
                                    <a-input v-model="formData.title" v-else />
                                </a-form-model-item>
                                <a-form-model-item>
                                    <strong>Project Sponsor/Leader:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.sponsor }}
                                    </div>
                                    <a-input v-model="formData.sponsor" v-else/>
                                </a-form-model-item>
                                <a-form-model-item>
                                    <strong>Tujuan Objektif:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.objective }}
                                    </div>
                                    <a-textarea v-model="formData.objective" :rows="4" v-else />
                                </a-form-model-item>
                                <a-form-model-item>
                                    <strong>Area/Lingkup Kerja:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.scope_of_work }}
                                    </div>
                                    <a-textarea v-model="formData.scope_of_work" :rows="4" v-else />
                                </a-form-model-item>
                            </a-card>
                        </a-col>
                        <a-col flex="1 1 250px">
                            <a-card type="inner" size="small" style="height: 100%">
                                <a-form-model-item>
                                    <strong>Anggota Tim:</strong><br>
                                    <div v-if="!edit">
                                        <ul>
                                            <li v-for="(member, k) in formData.team_members" :key="`member-${k}`">
                                                {{ member }}
                                            </li>
                                        </ul>
                                    </div>
                                    <a-textarea v-model="members" :rows="6" v-else/>
                                </a-form-model-item>
                                <a-form-model-item label="">
                                    <strong>Rencana Kerja:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.work_plan }}
                                    </div>
                                    <a-textarea v-model="formData.work_plan" :rows="6" v-else />
                                </a-form-model-item>
                            </a-card>
                        </a-col>
                    </a-row>

                    <a-card type="inner" size="small">
                        <a-row :gutter="24">
                            <a-col :span="8">
                                <a-form-model-item>
                                    <strong>Project KPI:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.kpi_project }}
                                    </div>
                                    <a-textarea v-model="formData.kpi_project" :rows="4" v-else/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item>
                                    <strong>Asumsi:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.assumptions }}
                                    </div>
                                    <a-textarea v-model="formData.assumptions" :rows="4" v-else/>
                                </a-form-model-item>
                            </a-col>
                            <a-col :span="8">
                                <a-form-model-item>
                                    <strong>Kendala:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.constrains }}
                                    </div>
                                    <a-textarea v-model="formData.constrains" :rows="4" v-else/>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </a-card>

                    <a-card type="inner" size="small">
                        <a-row type="flex">
                            <a-col flex="1 1 200px">
                                <a-row type="flex">
                                    <a-col :span="8">
                                        <a-form-model-item>
                                            <strong>Tanggal Mulai:</strong><br>
                                            <div v-if="!edit">
                                                <div v-if="formData.start_date != null">
                                                    {{ moment(formData.start_date).format('DD-MM-YYYY') }}
                                                </div>
                                            </div>
                                            <a-date-picker
                                                @change="onStartDateChange"
                                                :format="'YYYY-MM-DD'"
                                                v-model="formData.start_date"
                                                type="date"
                                                placeholder="Pilih tanggal"
                                                v-else
                                            />
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item>
                                            <strong>Tanggal Berakhir:</strong><br>
                                            <div v-if="!edit">
                                                <div v-if="formData.target_date != null">
                                                    {{ moment(formData.target_date).format('DD-MM-YYYY') }}
                                                </div>
                                            </div>
                                            <a-date-picker
                                                @change="onTargetDateChange"
                                                :format="'YYYY-MM-DD'"
                                                v-model="formData.target_date"
                                                type="date"
                                                placeholder="Pilih tanggal"
                                                v-else
                                            />
                                        </a-form-model-item>
                                    </a-col>
                                    <a-col :span="8">
                                        <a-form-model-item>
                                            <strong>Tanggal Berakhir Sebenarnya:</strong><br>
                                            <div v-if="!edit">
                                                <div v-if="formData.actual_date != null">
                                                    {{ moment(formData.actual_date).format('DD-MM-YYYY') }}
                                                </div>
                                            </div>
                                            <a-date-picker
                                                @change="onActualDateChange"
                                                :format="'YYYY-MM-DD'"
                                                v-model="formData.actual_date"
                                                type="date"
                                                placeholder="Pilih tanggal"
                                                v-else
                                            />
                                        </a-form-model-item>
                                    </a-col>
                                </a-row>
                            </a-col>
                            <a-col flex="0 1 300px">
                                <a-form-model-item>
                                    <strong>Persetujuan:</strong><br>
                                    <div v-if="!edit">
                                        {{ formData.approved_personnel }}
                                    </div>
                                    <a-input v-model="formData.approved_personnel" v-else />
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </a-card>

                    <a-card type="inner" size="small" v-if="isAttendant">
                        <a-row type="flex" justify="center">
                            <a-col :span="4">
                                <a-form-model-item>
                                    <a-space>
                                        <div v-if="!editing">
                                            <a-button
                                                type="primary"
                                                @click="handleSubmit"
                                                :loading="processing"
                                                :disabled="processing"
                                               >
                                                Simpan
                                            </a-button>
                                        </div>
                                        <div v-else>
                                            <a-button
                                                type="primary"
                                                @click="handleSubmit"
                                                :loading="processing"
                                                :disabled="processing"
                                                v-if="edit == true">
                                                Simpan
                                            </a-button>
                                            <a-button @click="editData">
                                                <div v-if="!edit">
                                                    Edit
                                                </div>
                                                <div v-else>Tutup</div>
                                            </a-button>
                                        </div>
                                    </a-space>
                                </a-form-model-item>
                            </a-col>
                        </a-row>
                    </a-card>
                </a-card>
            </a-form-model>
        </a-skeleton>
        <br>
        <a-skeleton :loading="loading" active>
            <a-form-model :model="formData" :rules="rules" ref="ruleForm">
                <a-card type="inner" size="small" v-if="charter_id != ''">
                    <a-card type="inner" size="small">
                        <a-row type="flex">
                            <a-col flex="1 1 200px">
                                <a-row type="flex">
                                    <a-col :span="8">
                                        <a-form-model-item>
                                            <strong>Lampiran:</strong><br>
                                            <div v-if="edit">
                                                <a-upload
                                                    :file-list="fileList"
                                                    :remove="handleRemove"
                                                    :before-upload="beforeUpload"
                                                    @change="handleChange"
                                                >
                                                    <a-button>
                                                        <a-icon type="upload" /> Upload
                                                    </a-button>
                                                </a-upload>
                                                <a-button
                                                    type="primary"
                                                    @click="handleUpload"
                                                    :loading="processing"
                                                    :disabled="processing"
                                                >
                                                    Simpan
                                                </a-button>
                                            </div>
                                            <template v-for="item in files.attachments">
                                                <a-button type="link" size="small" @click="download(item.file_path)">
                                                    <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> {{ item.file_name }}
                                                </a-button>
                                                <a-tooltip title="Hapus">
                                                <a-button
                                                    size="small"
                                                    type="danger"
                                                    icon="delete"
                                                    @click="showConfirm(item.id)"
                                                />
                                            </a-tooltip>
                                                <br/>
                                            </template>
                                        </a-form-model-item>
                                    </a-col>
                                </a-row>
                            </a-col>
                        </a-row>
                    </a-card>

                </a-card>
            </a-form-model>
        </a-skeleton>
    </div>
</template>

<script>
import moment from 'moment'

export default {
    props:{
        charter: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            processing: false,
            edit: true,
            items: {
                charters: []
            },
            formData: {
                title: ''
            },
            fileList: [],
            rules: {
                title: [{ required: true, message: 'Judul harus diisi', trigger: 'blur' }],
            },
            files: {},
            charter_id: this.charter,
            attendant: null,
            members: ''
        }
    },
    created() {

        if(!this.isAttendant){
            let urlParams = new URLSearchParams(window.location.search)

            this.attendant = urlParams.get('attendant')
        }

        if (this.editing) {
            this.edit = false
            this.getItems()
            this.getFiles()
        }
    },
    computed: {
        editing() {
            return this.charter !== ""
        },
        isAttendant() {
            return this.$laravel.membership.is_attendant
        }
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.project-management.charter.show', {charter: this.charter_id}) + '?outline=project_evaluation')
                .then(response => (this.items = response.data))
                .catch(error => {
                    if(error.response.status != 404){
                        this.handleXhrError(error)
                    }
                })
                .finally(() => (this.loading = false))
        },
        getFiles() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.project-management.charter-files.index', {charter: this.charter_id}) + '?outline=project_evaluation')
                .then(response => (this.files = response.data))
                .catch(error => {
                    if(error.response.status != 404){
                        this.handleXhrError(error)
                    }
                })
                .finally(() => (this.loading = false))
        },
        editData(){
            this.edit = !this.edit
        },
        handleSubmit(e) {
            e.preventDefault()

            this.$refs.ruleForm.validate(valid => {
                if(valid){
                    this.processing = true

                    if(this.formData.start_date != null)
                        this.formData.start_date = moment(this.formData.start_date).format('YYYY-MM-DD')

                    if(this.formData.target_date != null)
                        this.formData.target_date = moment(this.formData.target_date).format('YYYY-MM-DD')

                    if(this.formData.actual_date != null)
                        this.formData.actual_date = moment(this.formData.actual_date).format('YYYY-MM-DD')

                    if(this.editing){
                        this.$http.put(this.routeUri('api.project-management.charter.update', {charter: this.charter_id}), this.formData)
                            .then((response) => this.handleSuccessResponse(response.data))
                            .catch((error) => this.handleResponseError(error.response.data))
                            .finally(() => this.processing = false)
                    }else{
                        this.$http.post(this.routeUri('api.project-management.charter.create'), this.formData)
                            .then((response) => this.handleSuccessResponse(response.data))
                            .catch((error) => this.handleResponseError(error.response.data))
                            .finally(() => this.processing = false)
                    }

                }else{
                    return false
                }
            })
        },
        handleUpload(e) {
            e.preventDefault()

            this.$refs.ruleForm.validate(valid => {
                if(valid){
                    this.processing = true

                    var data = new FormData();

                    data.append("attachment", this.fileList[0]);

                     this.$http.post(this.routeUri('api.project-management.charter-files.uploads', {charter: this.charter_id}), data)
                        .then((response) => this.handleSuccessResponse(response.data))
                        .catch((error) => this.handleResponseError(error.response.data))
                        .finally(() => this.processing = false)

                }else{
                    return false
                }
            })
        },
        showConfirm(file) {
            var msg = 'Anda yakin?'

            this.$confirm({
                title: 'Konfirmasi',
                content: msg,
                onOk: () => {
                    this.handleDelete(file)
                },
                onCancel() {},
                class: 'test',
            });
        },
        handleDelete(file) {
            this.processing = true;

            let promise;

            promise = this.$http.delete(
                this.routeUri("api.project-management.charter-files.destroy", {charter: this.charter_id, attachment: file})
            );

            promise
                .then(response =>
                    this.handleSuccessResponse(response.data)
                )
                .catch(error =>
                    this.handleResponseError(error.response.data)
                )
                .finally(() => (this.processing = false));
        },
        handleSuccessResponse(data) {
            var successMessage = "Data berhasil diproses!"

            if (typeof data.successMessage != "undefined") {
                successMessage = data.successMessage
            }

            this.$notification.success({
                message: "Sukses!",
                description: successMessage
            })

            //setTimeout(() => this.redirect(), 1000)
            if(data.charter != null){
                this.charter_id = data.charter.id
                let params = {
                    charter: this.charter_id
                }
                setTimeout(() => window.location.replace(this.routeUri('admin.project.charter') + '?' + this.$qs.stringify(params)), 1000)
            }else{
                let params = {
                    charter: this.charter_id
                }
                setTimeout(() => window.location.replace(this.routeUri('admin.project.charter') + '?' + this.$qs.stringify(params)), 1000)
            }
        },
        handleResponseError(data) {
            if (data.hasOwnProperty("errors")) {
                for (let key in data.errors) {
                    this.$notification.error({
                        message: "Gagal proses " + key,
                        description: Object.values(data.errors[key])
                    });
                }
            } else {
                this.$notification.error({
                    message: "Gagal proses",
                    description: "Data tidak dapat diproses."
                });
            }
        },
        onStartDateChange(date, dateString) {
            this.formData.start_date = dateString
        },
        onTargetDateChange(date, dateString) {
            this.formData.target_date = dateString
        },
        onActualDateChange(date, dateString) {
            this.formData.actual_date = dateString
        },
        back() {
            if(!this.isAttendant){
                let params = {
                    attendant: this.attendant
                }

                window.location.href = this.routeUri('admin.project.documentation') + '?' + this.$qs.stringify(params)
            }else{
                window.location.href = this.routeUri('admin.project.charter.list')
            }
        },
        redirect() {
            window.location.href = this.routeUri('admin.project.charter.list')
        },
        handleRemove(file) {
            const index = this.fileList.indexOf(file);
            const newFileList = this.fileList.slice();

            newFileList.splice(index, 1);

            this.fileList = newFileList;
        },
        beforeUpload(file) {
            this.fileList = [...this.fileList, file];

            return false;
        },
        handleChange(info) {
            let fileList = [...info.fileList];

            if (fileList.length > 1) {
                fileList = fileList.slice(-1);

                fileList = fileList.map(file => {
                    if (file.response) {
                        file.url = file.response.url;
                    }
                    return file;
                });
                this.fileList = fileList;
            }
        },
        download(url) {
            window.open(window.location.origin + url, '_blank')
        },
    },
    watch: {
        members: function(value) {
            this.formData.team_members = value.split('\n')
        },
        items: function(value) {
            if(value.id != null){
                this.formData.title = value.title
                this.formData.sponsor = value.sponsor
                this.formData.objective = value.objective
                this.formData.team_members = value.team_members
                this.formData.scope_of_work = value.scope_of_work
                this.formData.work_plan = value.work_plan
                this.formData.kpi_project = value.kpi_project
                this.formData.assumptions = value.assumptions
                this.formData.constrains = value.constrains
                this.formData.start_date = value.start_date
                this.formData.target_date = value.target_date
                this.formData.actual_date = value.actual_date
                this.formData.approved_personnel = value.approved_personnel
                this.formData.attachment_file = value.attachment_file

                this.members = value.team_members.join('\n')
            }
        }
    }
}
</script>
